export function getPricePattern(decimalDigits) {
    let pattern = '[1-9]\\d*';
    if (decimalDigits) {
        pattern += '|(0|[1-9]\\d*)\\.\\d{1,' + decimalDigits + '}';
    }
    return pattern;
}

export const getExtname = (() => {
    const regex = /\.([a-z0-9]+)$/i;
    return function getExtname(path) {
        const matches = regex.exec(path);
        if (matches) {
            return matches[1];
        }
    };
})();
